import { useSelector, useDispatch } from 'react-redux';


import { useState, useEffect } from "react";

// react-router components
import { useLocation, Link } from "react-router-dom";
//mport { clearInvoices, userActions } from '../../../../helpers/store';

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";
import { authActions } from '../../../../helpers/store';

// @mui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";

// Argon Dashboard 2 MUI components
import ArgonBox from "../../ArgonBox";
import ArgonTypography from "../../ArgonTypography";
import ArgonInput from "../../ArgonInput";

// Argon Dashboard 2 MUI example components
import Breadcrumbs from "../../Breadcrumbs";
import NotificationItem from "../../Items/NotificationItem";
import SearchIcon from '@mui/icons-material/Search';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SettingsIcon from '@mui/icons-material/Settings';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import LogoutIcon from '@mui/icons-material/Logout';
import Divider from '@mui/material/Divider';
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarDesktopMenu,
  navbarMobileMenu,
} from "../../Navbars/DashboardNavbar/styles";


// Images
import team2 from "../../../../assets/images/team-2.jpg";
import logoSpotify from "../../../../assets/images/small-logos/logo-spotify.svg";
import { setMiniSidenav, setTransparentNavbar , setOpenMenu, setDarkMode, setDirection, setOpenConfigurator} from '../../../../slices/page.slice';
import { clearInvoices } from '../../../../slices/invoices.slice';
import { clearStatistics } from '../../../../slices/statistics.slice';

function DashboardNavbar({ absolute, light, isMini , appRoutes}) {

  const page = useSelector(x => x.page);
  const dispatch = useDispatch();
  const { user: authUser } = useSelector(x => x.auth);

  const darkMode = page.darkMode;
  const miniSidenav = page.miniSidenav;
  const transparentNavbar = page.transparentNavbar;
  const fixedNavbar = page.fixedNavbar;
  const openConfigurator = page.openConfigurator;
  const defaultValues = JSON.parse(localStorage.getItem('defaultValue'));

  const [navbarType, setNavbarType] = useState();
  const [openMenu, setOpenMenu] = useState(false);
  const route = useLocation().pathname.split("/").slice(1);

  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }
    
    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      dispatch(setTransparentNavbar((fixedNavbar && window.scrollY === 0) || !fixedNavbar));
      //setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => dispatch(setMiniSidenav(!miniSidenav));
  const handleConfiguratorOpen = () => dispatch(setOpenConfigurator(!openConfigurator));
  const handleOpenMenu = (event) => dispatch(setOpenMenu(event.currentTarget));
  const handleCloseMenu = () => dispatch(setOpenMenu(false));

  //console.log("GET APP ROUTE");
  //console.log(appRoutes);
  //console.log(route[route.length - 1]);
//  let tabTitle = appRoutes.find(o => o.name === route[route.length - 1].toLocaleLowerCase());
  // Render the notifications menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      {/*
      <NotificationItem
        image={<img src={team2} alt="person" />}
        title={["New message", "from Laur"]}
        date="13 minutes ago"
        onClick={handleCloseMenu}
      />
      <NotificationItem
        image={<img src={logoSpotify} alt="person" />}
        title={["New album", "by Travis Scott"]}
        date="1 day"
        onClick={handleCloseMenu}
      />
      <NotificationItem
        color="secondary"
        image={
          <Icon fontSize="small" sx={{ color: ({ palette: { white } }) => white.main }}>
            payment
          </Icon>
        }
        title={["", "Payment successfully completed"]}
        date="2 days"
        onClick={handleCloseMenu}
      />
      */}
      
    </Menu>
  );
  const logout = () => {

    dispatch(clearInvoices());
    dispatch(clearStatistics());
    dispatch(authActions.logout());

  }

  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) => navbar(theme, { transparentNavbar, absolute, light })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        
        <ArgonBox
          color={light && transparentNavbar ? "white" : "dark"}
          mb={{ xs: 1, md: 0 }}
          sx={(theme) => navbarRow(theme, { isMini })}
        >
                    { miniSidenav ?   <MenuOpenIcon fontSize="large" sx={navbarDesktopMenu} onClick={handleMiniSidenav}/>:<MenuIcon fontSize="large" sx={navbarDesktopMenu} onClick={handleMiniSidenav}/> }

          <Breadcrumbs
            title={appRoutes.find(o => o.name === route[route.length - 1].toLocaleLowerCase()) ? appRoutes.find(o => o.name === route[route.length - 1].toLocaleLowerCase()).title : ""}
            route={route}
            light={transparentNavbar ? light : false}
          />
        </ArgonBox>
        {/*{ miniSidenav ? */}
        <ArgonBox
              color={light && transparentNavbar ? "white" : "dark"}
              mb={{ xs: 1, md: 0 }}
              sx={(theme) => navbarRow(theme, { isMini })}>
              {(authUser.role === "CustomerPortal") || (authUser.role === "FinancialPersonnel") ? <span>
                <span>{authUser?.username}</span> &nbsp;&nbsp;
                مانده :  <h6 style={{textAlign : 'left'}}>{defaultValues != null && defaultValues.CustomerSaleAndFinancialDataModel !== null ? (defaultValues.CustomerSaleAndFinancialDataModel.a8 !== null ? (defaultValues.CustomerSaleAndFinancialDataModel.a8.includes("-") ? "0" : defaultValues.CustomerSaleAndFinancialDataModel.a8 ) : "0" ) +  " ریال" : ""}</h6></span>
                    : <span>{authUser?.username}</span> }
        </ArgonBox>
     {/* : ""} */}
        {isMini ? null : (
          <ArgonBox sx={(theme) => navbarRow(theme, { isMini })}>
            <ArgonBox color={light ? "white" : "inherit"}>
                <IconButton sx={navbarIconButton} size="small">
                  <AccountCircleIcon fontSize="small"
                   sx={({ palette: { dark, white } }) => ({
                    color: light && transparentNavbar ? white.main : dark.main,
                  })}/>
                  <Divider orientation="horizontal"  /> 
                   {/*
                  <IconButton onClick={logout} color={light && transparentNavbar ? "white" : "dark"}>
                    <LogoutIcon />
                  </IconButton>
                 */}
                 { miniSidenav ?
                  <ArgonTypography
                    component="span"
                    variant="button"
                    fontWeight="regular"
                    textTransform="capitalize"
                    color={light ? "white" : "dark"}
                    sx={{ lineHeight: 0 }}
                  >
                  {authUser?.fullname}   
                  </ArgonTypography>
                 : ""}
                </IconButton>
            {
              <IconButton
                size="small"
                color={light && transparentNavbar ? "white" : "dark"}
                sx={navbarMobileMenu}
                onClick={handleMiniSidenav}
              >
                <Icon>{miniSidenav ? <MenuIcon /> : <MenuOpenIcon/>}</Icon>
              </IconButton>
                }
              <IconButton
                size="small"
                color={light && transparentNavbar ? "white" : "dark"}
                sx={navbarIconButton}
                onClick={handleConfiguratorOpen}
              >
               <SettingsIcon />
              </IconButton>
              <IconButton
                size="small"
                color={light && transparentNavbar ? "white" : "dark"}
                sx={navbarIconButton}
                aria-controls="notification-menu"
                aria-haspopup="true"
                variant="contained"
                onClick={handleOpenMenu}
              >
                <NotificationsIcon />
              
              </IconButton>
              {renderMenu()}
            </ArgonBox>
          </ArgonBox>
        )}
      </Toolbar>
    </AppBar>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: true,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
